import { render, staticRenderFns } from "./combo.vue?vue&type=template&id=027ef8da"
import script from "./combo.vue?vue&type=script&lang=js"
export * from "./combo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports